import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { ItemsLanguages } from "../../app/api/packbo/models/items-languages";

@Injectable({
    providedIn: "root"
})
export class DirectusTranslationService {
    private readonly translocoService = inject(TranslocoService);

    getTranslation<
        T extends {
            languages_code?: string | ItemsLanguages | null;
            [key: string]: unknown;
        }
    >(translations: (T | number)[] | null | undefined, property: keyof T): string {
        if (!translations || !Array.isArray(translations) || translations.length === 0) {
            return "";
        }

        const currentLang = this.translocoService.getActiveLang();

        const translationObjects = translations.filter(
            (item): item is T => typeof item === "object" && item !== null
        ) as T[];

        if (translationObjects.length === 0) {
            return "";
        }

        const currentTranslation = translationObjects.find((translation) => {
            if (!translation.languages_code) {
                return false;
            }

            const langCode =
                typeof translation.languages_code === "string"
                    ? translation.languages_code
                    : translation.languages_code?.code;

            return langCode.includes(currentLang);
        });

        const fallbackTranslation = translationObjects.find((translation) => {
            if (!translation.languages_code) {
                return false;
            }

            const langCode =
                typeof translation.languages_code === "string"
                    ? translation.languages_code
                    : translation.languages_code?.code;

            return langCode.includes("fr");
        });

        const selectedTranslation = currentTranslation || fallbackTranslation || translationObjects[0];

        return (selectedTranslation?.[property] as string) || "";
    }
}
